<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="dailyEpense"
          class="elevation-1"
          item-key="_id"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="grey lighten-4">
              <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
              >

              <v-divider class="mx-4" inset vertical></v-divider>
              <!-- <div class="flex-grow-1"></div> -->
              <searchDate
                Thismonth
                :searching="searching"
                :SearchFun="DailyExpense"
              ></searchDate>
              <v-spacer></v-spacer>
              <!-- {{ total }} -->
              <div>
                <cashDisplay
                  small
                  :isloading="searching"
                  :Balance="total"
                ></cashDisplay>
              </div>
            </v-toolbar>
          </template>

          <template v-slot:[`item.Amount`]="{ item }">
            {{ item.Amount.toLocaleString() }}
            <strong>{{ item.AmountType | MoneySigns }}</strong>
          </template>

          <template v-slot:[`item.Ref`]="{ item }">
            <base-row-layout>
              <!-- Dail Expens Delete Icon -->
              <div>
                <BaseDelete
                  v-if="UsersToken.UserType === 'Admin'"
                  :OnFinish="
                    () => {
                      DailyExpense(fromDate, toDate);
                    }
                  "
                  :DelQuery="{ Ref: item.Ref }"
                  DelUrl="/Reports/deleteRef"
                >
                  <template #title>
                    DELETE
                    <span class="black--text">{{ item.Description }}</span>
                  </template>

                  <v-row>
                    <v-col>{{ item.date }}</v-col>
                    <!-- <v-col>{{ item.Description }}</v-col> -->
                    <v-col>{{ item.Details }}</v-col>
                    <v-col>{{
                      item.Amount && item.Amount.toLocaleString()
                    }}</v-col>
                  </v-row>
                  <!-- <p>{{ item }}</p> -->
                </BaseDelete>
              </div>
              <!-- Edite Date Icon -->
              <div>
                <base-edite-date
                  :Info="item"
                  BaseURL="/expense"
                  :FinishedWithdrow="
                    () => {
                      item.OnSearch(item.fromDate, item.toDate);
                    }
                  "
                ></base-edite-date>
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <EntryExp :onFinshed="loudExpense"></EntryExp>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import EntryExp from "@/components/Branches/Expense/ExpEntry.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    EntryExp,
    searchDate: () => import("@/components/util/searchDate.vue"),
    cashDisplay: () => import("@/components/coman/cashView"),
  },
  data() {
    return {
      searching: false,
      ExpenseURL: "/Reports/expense/daily",
      search: "",
      fromDate: "",
      toDate: "",
      dailyEpense: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Reason", value: "Description" },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Amount", value: "Amount" },
        // { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    total() {
      return this.dailyEpense.reduce(
        (blc, item) => {
          blc = [
            {
              AmountType: item.AmountType,
              Amount: item.Amount + blc[0].Amount,
            },
          ];
          return blc;
        },
        [
          {
            AmountType: "",
            Amount: 0,
          },
        ]
      );
    },
  },
  methods: {
    DailyExpense(from, to) {
      this.searching = true;
      this.$store
        .dispatch("FIND_BY_VALUE", {
          url: this.ExpenseURL,
          query: { from, to },
        })
        .then(result => {
          // console.log(result);
          this.searching = false;
          this.dailyEpense = result.data;
        });
    },
    loudExpense() {
      this.fromDate = this.Current().Thismonth;
      this.toDate = this.Current().date;
      // Thismonth
      this.DailyExpense(this.fromDate, this.toDate);
    },
  },
  created() {
    // this.DailyExpense();
    this.loudExpense();
  },
};
</script>
